import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet, Link, useParams } from "react-router-dom";
import axios from 'axios';
// import { useNavigate } from 'react-router-dom';

const Sidebar = () => {
    // let history = useNavigate();
    const [cat,setCat]=useState([]);
    useEffect(()=>{
        loadUsers();
    },
    []
    )
    const loadUsers = async ()=>{
        const result = await axios.get("https://acesoftech.co.in/tanzil/ecomAPI/tanzil_blog/categories/view_category.php")
        setCat(result.data.records);
        //console.log(result.data)
    }
    
  return (
    <div>
        <div id="eskimo-sidebar">
                    <div id="eskimo-sidebar-wrapper" className="d-flex align-items-start flex-column h-100 w-100">
                        <div id="eskimo-logo-cell" className="w-100">
                            <Link to={`/`} className="eskimo-logo-link">
                                <img src="images/logo_1.png" className="eskimo-logo" alt="eskimo" />
                            </Link>
                        </div>
                        <div id="eskimo-sidebar-cell" className="w-100">
                            <div id="eskimo-menu-toggle">Category</div>
                            <nav id="eskimo-main-menu" className="menu-main-menu-container">
                                <ul className="eskimo-menu-ul">
                                {cat.map((cat, index) => (
                                    <li><Link  to={`/cat-list/${cat.id}`}>{cat.category_name}</Link></li>
                                ))}
                                </ul>
                            </nav>
                        </div>
                        <div id="eskimo-social-cell" className="mt-auto w-100">
                            <div id="eskimo-social-inner">
                                <ul className="eskimo-social-icons">
                                    <li><a href="#"><i className="fa fa-facebook-f"></i></a></li>
                                    <li><a href="#"><i className="fa fa-twitter"></i></a></li>
                                    <li><a href="#"><i className="fa fa-google-plus"></i></a></li>
                                    <li><a href="#"><i className="fa fa-instagram"></i></a></li>
                                    <li><a href="#"><i className="fa fa-vimeo"></i></a></li>
                                </ul>
                                <div className="clearfix"></div>
                            </div>
                        </div>
                    </div>
                </div>
    </div>
  )
}

export default Sidebar